import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getIndustryGroups, saveBatchIndustryGroups } from '../../api/industryGroups';
import type { IndustryGroup } from '../../types/IndustryGroup';
import { t } from '../../i18n/t';

const columnDefs: ColDef<IndustryGroup>[] = [
  {
    field: 'industryGroupId',
    headerName: t('industryGroups.columns.industryGroupId'),
    width: 140,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<IndustryGroup>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'industryGroupName', headerName: t('industryGroups.columns.industryGroupName'), flex: 1, editable: true },
];

const newRowDefaults = (): Partial<IndustryGroup> => ({ industryGroupId: 0, industryGroupName: '' });

export function IndustryGroupsPage() {
  return (
    <LopCrudPage<IndustryGroup>
      resourceCode="industryGroups"
      titleKey="industryGroups.pageTitle"
      idField="industryGroupId"
      getRows={getIndustryGroups}
      saveBatch={(added, modified, deletedIds) => saveBatchIndustryGroups(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
